var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"news_app_statistics_overview__wrapper news_module"},[_c('NewsAppStatistics',{attrs:{"expanded":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }